import { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getStoredTokens } from '@/core/utils/security.ts'

interface Props {
  children: ReactNode
  ifLoggedTo: string
}

export const LogoutGuard = ({ children, ifLoggedTo }: Props) => {
  const authToken = getStoredTokens()

  if (authToken) {
    return <Navigate to={ifLoggedTo} />
  }

  return children ? children : <Outlet />
}
